import React from "react";
import smooch from "smooch";


export const zingleWebWidgetInitialize = (props, callback) => {

    const { t } = props;

    console.log("Zingle Interface initialized for web")
    let room = localStorage.getItem("room");
    let checkedInGuestInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))


    const getUnreadMessageCount = () => {

        const handleUnreadMessageCount = () => {
            smooch.getConversationById()
            .then((res) => {
                console.log("unread count - zingleGet: " + res.participants[0].unreadCount);
                props.setUnreadMessageCountWeb(res.participants[0].unreadCount)
            })
            .catch((err) => console.log("Error retrieving Smooch Conversation"))
        }

        handleUnreadMessageCount();
        if(!props.zingleOnInitiated){
            props.setZingleOnStatus(true);
            smooch.off();

            smooch.on('message:received', handleUnreadMessageCount);
            smooch.on('widget:closed', handleUnreadMessageCount);
        }
    }


    if (!window.device) {

        const ZingleLoginCred = JSON.parse(localStorage.getItem("zingleCred"))

        if (((!room || room == "null") || (!ZingleLoginCred || Object.keys(ZingleLoginCred).length == 0)) && props.freshChatData.logout.webIntegrationId) {
            smooch.init({
                integrationId: props.freshChatData.logout.webIntegrationId, buttonWidth: '0', buttonHeight: '0',
                businessName : props.freshChatData.logout.businessName || null,
                businessIconUrl: props.freshChatData.logout.businessIconUrl || null,
                canUserSeeConversationList: props.freshChatData.logout.canUserSeeConversationList || false,
                customColors: {
                    brandColor: props.menuColor.assetBackgroundSelectorColor.replace("#",""),
                    conversationColor: props.menuColor.assetBackgroundSelectorColor.replace("#",""),
                    actionColor: props.menuColor.assetBackgroundSelectorColor.replace("#",""),
                },
            })
                .then(() => {
                    console.log("Zingle Interface initialized for web - successfull")
                    props.setChatWidgetInnitialized(true);
                    sessionStorage.setItem("smoochInit", true)

                    const iframe = document.getElementById("web-messenger-container");
                    iframe.width = "0";
                    iframe.height = "0";

                    getUnreadMessageCount();
                })
                .catch((err) => {
                    console.log("Error init Zingle")
                    console.log(err)

                    const iframe = document.getElementById("web-messenger-container");
                    iframe.style.width = "0";
                    iframe.style.height = "0";
                    iframe.style.zIndex = "-1";
                })
        } else if (ZingleLoginCred && props.freshChatData.login.webIntegrationId) {
            smooch.init({
                integrationId: props.freshChatData.login.webIntegrationId, jwt: ZingleLoginCred.jwtToken, externalId: ZingleLoginCred.externalId, buttonWidth: '0', buttonHeight: '0',
                businessName : props.freshChatData.login.businessName || null,
                businessIconUrl: props.freshChatData.login.businessIconUrl || null,
                canUserSeeConversationList:  props.freshChatData.logout.canUserSeeConversationList || false,
                customColors: {
                    brandColor: props.menuColor.assetBackgroundSelectorColor.replace("#",""),
                    conversationColor: props.menuColor.assetBackgroundSelectorColor.replace("#",""),
                    actionColor: props.menuColor.assetBackgroundSelectorColor.replace("#",""),
                },
            })
                .then(() => {
                    console.log("Zingle Interface initialized for web - successfull")
                    props.setChatWidgetInnitialized(true);
                    sessionStorage.setItem("smoochInit", true)

                    const iframe = document.getElementById("web-messenger-container");
                    iframe.width = "0";
                    iframe.height = "0";


                    setTimeout(() => {
                        if (checkedInGuestInfo && checkedInGuestInfo[0] && checkedInGuestInfo[0].guestProfile.firstName) {
                            smooch.updateUser({
                                givenName: checkedInGuestInfo[0].guestProfile.firstName,
                                surname: checkedInGuestInfo[0].guestProfile.lastName ? checkedInGuestInfo[0].guestProfile.lastName : "",
                                email: checkedInGuestInfo[0].guestProfile.email ? checkedInGuestInfo[0].guestProfile.email : "",
                                metadata: {
                                    [t('zingleMetaDataKey.room')]: localStorage.getItem("room"),
                                    [t('zingleMetaDataKey.profile_id')]: checkedInGuestInfo[0].guestProfile.pmsProfileId,
                                    [t('zingleMetaDataKey.confirmation_number')] : checkedInGuestInfo[0].reservationNumber
                                }
                            })
                        } else if(checkedInGuestInfo && checkedInGuestInfo[0]) {
                            smooch.updateUser({
                                surname: checkedInGuestInfo[0].guestProfile.lastName ? checkedInGuestInfo[0].guestProfile.lastName : "",
                                email: checkedInGuestInfo[0].guestProfile.email ? checkedInGuestInfo[0].guestProfile.email : "",
                                metadata: {
                                    [t('zingleMetaDataKey.room')]: localStorage.getItem("room"),
                                    [t('zingleMetaDataKey.profile_id')]: checkedInGuestInfo[0].guestProfile.pmsProfileId,
                                    [t('zingleMetaDataKey.confirmation_number')] : checkedInGuestInfo[0].reservationNumber
                                }
                            })
                        }
                    }, 1000);

                    if (props.freshChatData.login.startConverastionMsg) {
                        setTimeout(() => {
                            smooch.getConversationById().catch((err) => {
                                if (err.status == 404) {
                                    smooch.createConversation({
                                        messages: [
                                            {
                                                text: props.freshChatData.login.startConverastionMsg,
                                                type: 'text',
                                            },
                                        ],
                                    }).then((conversation) => {
                                        console.log("successfully started conversation with Zingle in app backgound")
                                    })
                                        .catch((err) => {
                                            console.log("Error sending sms")
                                        })
                                }
                            })
                        }, 3000);
                    }

                    getUnreadMessageCount();
                })
                .catch((err) => {
                    console.log("Error init Zingle")
                    console.log(err)

                    const iframe = document.getElementById("web-messenger-container");
                    iframe.style.width = "0";
                    iframe.style.height = "0";
                    iframe.style.zIndex = "-1";
                })
        } else {
            console.log("Error Init Zingle")
        }
    }

    callback(true);

}

export const zingleWebWidgetShowConversation = () => {
    console.log("Zingle show conversation called for web")

    if (sessionStorage.getItem("smoochInit")) {
        smooch.open();

        const user = smooch.getUser();
        console.log(user);
    } else {
        console.log("Error opening Zingle widget")
    }
}